import * as React from "react";
const SvgFiRrTintSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tint-slash_svg__a)">
      <path
        fill="#062147"
        d="M12 24c-2.938 0-5.7-1.145-7.778-3.222A10.93 10.93 0 0 1 1 13c0-1.38.453-2.89 1.345-4.487a1 1 0 1 1 1.746.974c-.724 1.297-1.09 2.479-1.09 3.513 0 2.403.936 4.664 2.635 6.364A8.95 8.95 0 0 0 12 22a9.04 9.04 0 0 0 4.05-.96 1 1 0 1 1 .901 1.785A11 11 0 0 1 12.001 24m0-21c-.467 0-.919.165-1.272.465a36 36 0 0 0-2.953 2.801l-.046.049 11.006 11.006A7.94 7.94 0 0 0 20 12.999c0-2.395-2.515-5.959-6.728-9.534A1.97 1.97 0 0 0 12 3M1 0c.256 0 .512.098.707.293L6.314 4.9a38 38 0 0 1 3.12-2.96A3.96 3.96 0 0 1 12 1c.914 0 1.828.313 2.566.94C17.53 4.454 22 8.988 22 12.999c0 2.02-.608 4.04-1.825 5.762l3.532 3.532a.999.999 0 1 1-1.414 1.414l-22-22A.999.999 0 0 1 1 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tint-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTintSlash;
